<template>
	<div class="Modal">
		<div class="header">WAAROM BREEK JE DE SUPPORT TICKET AF?</div>
		<form @submit.prevent="cancelSupportTicket">
			<textarea v-model="cancelReason"></textarea>
			<span v-if="isCancelReasonValid === false" class="error-message">Mag niet leeg zijn</span>
			<button class="primary submit button" type="submit">AFBREKEN</button>
		</form>
	</div>
</template>

<script>

import {client} from "../../store";
import {mapActions} from "vuex";

export default {
	name: "SupportTicketDetailCancelModal",
	props: {
		supportTicket: null,
		finishStep: null
	},

	data() {
		return {
			cancelReason: null,
			isCancelReasonValid: true
		}
	},

	methods: {
		...mapActions({
			setLoading: "map/setLoading",
			setIdle: "map/setIdle"
		}),

		cancelSupportTicket() {
			if (this.cancelReason == null || this.cancelReason.trim() === "") {
				this.isCancelReasonValid = false;
				return;
			} else {
				this.isCancelReasonValid = true;
			}

			this.setLoading();

			client.query(`
				mutation($support_ticket_id: ID!, $cancel_reason: String!, $project_id: ID!) {
					cancelSupportAppointment(support_ticket_id: $support_ticket_id, cancel_reason: $cancel_reason, project_id: $project_id)
				}
			`, {
				support_ticket_id: this.supportTicket.id,
				cancel_reason: this.cancelReason,
				project_id: this.supportTicket.project_id
			}).then(() => {
				this.setIdle();

				this.$notify({
					group: "app",
					title: "Support ticket updaten",
					type: "success",
					text: "Support ticket is succesvol aangepast"
				});

				this.finishStep(true);
				this.$emit("close");
			}).catch((error) => {
				console.error(error);
				this.setIdle();

				this.$notify({
					group: "app",
					title: "Support ticket update",
					type: "error",
					text: "Updaten mislukt"
				});
			});
		}
	}
}
</script>

<style scoped lang="scss">
.Modal {
	padding: 24px;
	font-size: 17px;

	.header {
		color: #d3455b;
		font-weight: 800;
		margin-bottom: 12px;
	}

	form {
		display: flex;
		flex-direction: column;
		gap: 12px;

		textarea {
			margin: 0;
			border: 2px solid #d2d2d2;
			box-shadow: none;
			color: #666;
			background-color: #fff;
			box-sizing: border-box;
			border-radius: 5px;
			padding: 0.5em;
			font-size: 1rem;
		}

		.error-message {
			color: red;
		}

		.button {
			width: 24%;
			background-color: #d3455b;
			border: none;
			color: #fff;
			border-radius: 5px;
			padding: 8px;
			align-self: flex-end;
			font-size: 1em;
			font-weight: 425;
		}
	}
}
</style>
